import React, { Fragment, memo } from 'react';
import { connect } from 'unistore/react';

import { Button } from '@components/Button';
import { withToast } from '@components/ToastNotifyHOC';

import { actionsRequiredActions } from '@utils/store/actions';

// import { hasOwn, checkDocument } from '@utils/customLib';

// let notifAlreadyShown = false;

// const ShowNotification = connect('tabInFocus')(
// 	({ tabInFocus, openForYouTab }) => {
// 		if (!notifAlreadyShown && !tabInFocus && checkDocument) {
// 			notifAlreadyShown = true;
// 			if (hasOwn(window, 'Notification')) {
// 				const Notif = window.Notification;

// 				try {
// 					if (Notif.permission === 'granted') {
// 						const notification = new Notif('New Actions Pending', {
// 							body: 'You have a some actions pending. ',
// 							icon:
// 								'https://bitbns.com/assets/img/logos/bitbns-96.png',
// 							requireInteraction: true,
// 							tag: 'ar',
// 							renotify: true,
// 						});
// 						notification.onclick = function(e) {
// 							e.preventDefault();
// 							window.focus();
// 							notifAlreadyShown = false;
// 							openForYouTab();
// 						};
// 					}
// 				} catch (err) {
// 					console.log('actionsRequired Notifs', err);
// 				}
// 			}
// 		}
// 		return null;
// 	}
// );

const AlertText = ({ openForYouTab, type, curr }) => {
	const upperCurr = curr.toUpperCase();
	const fullType = type === 'dep' ? 'Deposit' : 'Withdrawal';

	return (
		<div className="text-left flex items-start" onClick={openForYouTab}>
			<img
				src={`https://bitbns.com/assets/img/coinIcons/${curr}.png`}
				alt={`${upperCurr} ${fullType}"`}
				height="25"
				width="25"
				className="mr-4 rounded-full"
			/>
			<div className="flex-grow">
				<div className="font-bold">{fullType} Actions Pending</div>
				<div className="mt-2">
					There are some new updates for your P2P {upperCurr}{' '}
					{fullType} transactions.
				</div>
				<div className="mt-3">
					<Button
						variant="minimal"
						size="vtiny"
						onClick={openForYouTab}
					>
						Open Now
					</Button>
				</div>
			</div>
		</div>
	);
};

const MarginControlCenter = connect(
	`tabInFocus,
	marginOnGoing,
	marginReadNotSeen,
	marginInFreeze,
	marginInDepo,
	marginAboutToExpire,
	marginExpired,
	marginActionsNotSeen,
`,
	actionsRequiredActions
)(
	withToast(
		memo(
			({
				marginInFreeze,
				marginInDepo,
				marginActionsNotSeen,
				notify,
				// openForYouTab,
				openMarginActions,
				__setActionsRequiredRead,
			}) => {
				if (marginActionsNotSeen.size > 0) {
					const title =
						marginInFreeze || marginInDepo
							? 'Urgent Attention!'
							: 'Margin Trading';
					const text = marginInFreeze
						? 'One of your Margin orders is in Liquidation Zone'
						: marginInDepo
						? 'One of your Margin orders is in Deposit Zone.'
						: 'Some of your Margin Orders need attention!';

					notify(
						<div
							className="text-left flex items-start"
							onClick={openMarginActions}
						>
							<div className="flex-grow">
								<div className="font-bold">{title}</div>
								<div className="mt-2">{text}</div>
								<div className="mt-3">
									<Button
										variant="minimal"
										size="vtiny"
										className="text-white"
										onClick={openMarginActions}
									>
										Open Now
									</Button>
								</div>
							</div>
						</div>,
						{
							icon: (
								<img
									src={
										marginInFreeze || marginInDepo
											? 'https://bitbns.com/assets/img/appIcons/svg/dispute.svg'
											: 'https://bitbns.com/assets/img/appIcons/svg/alert.svg'
									}
									alt="Warning"
									height="25"
									width="25"
									className="-mb-8"
								/>
							),
							autoClose: false,
							onClose: () => {
								__setActionsRequiredRead('1');
							},
							type: 'warning',
							toastId: 'marginAlerts',
						}
					);

					// return <ShowNotification openForYouTab={openForYouTab} />;F
				}

				return null;
			}
		)
	)
);

const DepControlCenter = connect(
	`tabInFocus, 
	depActionsNotSeen,
`,
	actionsRequiredActions
)(
	withToast(
		memo(
			({
				depActionsNotSeen,
				notify,
				// openForYouTab,
				__setActionsRequiredRead,
				openDepoActions,
			}) => {
				if (depActionsNotSeen.size > 0) {
					notify(
						<AlertText
							type="dep"
							curr="inr"
							openForYouTab={openDepoActions}
						/>,
						{
							icon: false,
							type: 'default',
							autoClose: false,
							onClose: () => {
								__setActionsRequiredRead('2');
							},
							toastId: 'depositAlerts',
						}
					);

					// return <ShowNotification openForYouTab={openForYouTab} />;
				}

				return null;
			}
		)
	)
);

const DepUSDTControlCenter = connect(
	`tabInFocus,
	depActionsUSDTNotSeen,
`,
	actionsRequiredActions
)(
	withToast(
		memo(
			({
				depActionsUSDTNotSeen,
				notify,
				// openForYouTab,
				__setActionsRequiredRead,
				openDepoActions,
			}) => {
				if (depActionsUSDTNotSeen.size > 0) {
					notify(
						<AlertText
							type="dep"
							curr="usdt"
							openForYouTab={openDepoActions}
						/>,
						{
							icon: false,
							type: 'default',
							autoClose: false,
							onClose: () => {
								__setActionsRequiredRead('3');
							},
							toastId: 'depositUSDTAlerts',
						}
					);

					// return <ShowNotification openForYouTab={openForYouTab} />;
				}

				return null;
			}
		)
	)
);

const WithUSDTControlCenter = connect(
	`tabInFocus,
	withActionsUSDTNotSeen,
`,
	actionsRequiredActions
)(
	withToast(
		memo(
			({
				withActionsUSDTNotSeen,
				notify,
				// openForYouTab,
				__setActionsRequiredRead,
				openWithActions,
			}) => {
				if (withActionsUSDTNotSeen.size > 0) {
					notify(
						<AlertText
							type="with"
							curr="usdt"
							openForYouTab={openWithActions}
						/>,
						{
							icon: false,
							type: 'default',
							autoClose: false,
							onClose: () => {
								__setActionsRequiredRead('5');
							},
							toastId: 'withUSDTAlerts',
						}
					);

					// return <ShowNotification openForYouTab={openForYouTab} />;
				}

				return null;
			}
		)
	)
);

const WithControlCenter = connect(
	`tabInFocus, 
	withActionsNotSeen,
`,
	actionsRequiredActions
)(
	withToast(
		memo(
			({
				withActionsNotSeen,
				notify,
				// openForYouTab,
				__setActionsRequiredRead,
				openWithActions,
			}) => {
				if (withActionsNotSeen.size > 0) {
					notify(
						<AlertText
							type="with"
							curr="inr"
							openForYouTab={openWithActions}
						/>,
						{
							icon: false,
							type: 'default',
							autoClose: false,
							onClose: () => {
								__setActionsRequiredRead('4');
							},
							toastId: 'withAlerts',
						}
					);

					// return <ShowNotification openForYouTab={openForYouTab} />;
				}

				return null;
			}
		)
	)
);

const ProfileControlCenter = connect(
	`tabInFocus, 
	profileActionsNotSeen,
`,
	actionsRequiredActions
)(
	withToast(
		memo(
			({
				profileActionsNotSeen,
				notify,
				// openForYouTab,
				__setActionsRequiredRead,
				openProfileActions,
			}) => {
				if (profileActionsNotSeen.size > 0) {
					notify(
						<div
							className="text-left flex items-start"
							onClick={openProfileActions}
						>
							<div className="flex-grow">
								<div className="font-bold">
									Profile Completion
								</div>
								<div className="mt-2">
									There are some pending actions for your
									profile
								</div>
								<div className="mt-3">
									<Button
										variant="minimal"
										size="vtiny"
										className="text-white"
										onClick={openProfileActions}
									>
										Open Now
									</Button>
								</div>
							</div>
						</div>,
						{
							icon: (
								<img
									src="https://bitbns.com/assets/img/appIcons/svg/alert.svg"
									alt="Warning"
									height="25"
									width="25"
									className="-mb-8"
								/>
							),
							type: 'warning',
							autoClose: false,
							onClose: () => {
								__setActionsRequiredRead('6');
							},
							toastId: 'profileAlerts',
						}
					);

					// return <ShowNotification openForYouTab={openForYouTab} />;F
				}

				return null;
			}
		)
	)
);

const NotifsControlCenter = ({
	openMarginActions,
	openDepoActions,
	openWithActions,
	openForYouTab,
	openProfileActions,
}) => (
	<Fragment>
		<MarginControlCenter
			openMarginActions={openMarginActions}
			openForYouTab={openForYouTab}
		/>

		<DepControlCenter
			openForYouTab={openForYouTab}
			openDepoActions={openDepoActions}
		/>
		<DepUSDTControlCenter
			openForYouTab={openForYouTab}
			openDepoActions={openDepoActions}
		/>
		<WithControlCenter
			openForYouTab={openForYouTab}
			openWithActions={openWithActions}
		/>
		<WithUSDTControlCenter
			openForYouTab={openForYouTab}
			openWithActions={openWithActions}
		/>
		<ProfileControlCenter
			openForYouTab={openForYouTab}
			openProfileActions={openProfileActions}
		/>
	</Fragment>
);

export default NotifsControlCenter;
